<script lang="ts" setup>
import { computed, ref, toRefs } from 'vue';
import { Attendee, DetailedEventInterface, PastResultInterface } from '@/types';
import PastDocumentationGoal from '@/views/Calendar/components/PastDocumentationGoal.vue';

interface Props {
  event: DetailedEventInterface;
  attendee: Attendee;
  therapyResult: PastResultInterface['result'];
}

const props = defineProps<Props>();
const { event, attendee, therapyResult } = toRefs(props);

const goalsMeasurements = computed(() => {
  return therapyResult.value?.goals_measurements.filter((goal) => goal.id);
});

const isSessionEvent = event.value.therapy_event_type === 'Session';

const getSessionType = (studentId: number) => {
  if (!isSessionEvent) return;

  const sessionType = event.value.event_type_data?.session_types?.find(
    (sessionType) => sessionType.person_id === studentId,
  );

  const shortNames = {
    Regular: 'Reg.',
    'Approved Compensation': 'Approved Comp.',
    'Extended School Year': 'Extended School Year',
    'Make up': 'Make up',
  };

  return shortNames[sessionType?.therapy_session_type.name];
};

const isDocumented = ref(!!therapyResult.value?.id);
</script>

<template>
  <div class="p-3 bg-white border-round-lg mb-3">
    <div class="flex justify-content-between align-items-center">
      <div class="flex">
        <p class="font-bold text-lg">{{ attendee.attendee.full_name }}</p>
        <div v-if="isDocumented" class="flex align-items-center">
          <span
            class="mx-2"
            style="border-left-style: solid; border-left-width: 2px; border-left-color: #d4d9d9; height: 20px"
          />
          <p>{{ therapyResult.therapy_result_type.name }}</p>
        </div>
      </div>
      <p v-if="isSessionEvent">
        Session Type:
        <b>{{ getSessionType(attendee.attendee_id) }}</b>
      </p>
    </div>
    <!-- eslint-disable vue/no-v-html -->
    <p class="mt-3" v-html="attendee.notes" />
    <!--eslint-enable-->
    <PastDocumentationGoal v-for="goal in goalsMeasurements" :key="goal.id" :data="goal" />
  </div>
</template>
